// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { FieldValueSelectionResponse } from './field-value-selection-response';

// @ts-ignore
import { HistoryDiagnosisCarePlanItemResponse } from './history-diagnosis-care-plan-item-response';

/** See com.rev360.pms.api.controller.encounter.history.reasonforvisit.ReasonForVisitResponse */
/* istanbul ignore next */
@GandalfModel
export class ReasonForVisitResponse extends GandalfModelBase {

	@GandalfProperty({ designType: FieldValueSelectionResponse })
	additionalReason!: FieldValueSelectionResponse | null;

	@GandalfArray(HistoryDiagnosisCarePlanItemResponse)
	diagnosisCarePlanItems!: HistoryDiagnosisCarePlanItemResponse[] | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Boolean })
	isMedicalReasonForVisit!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	isTransitionOfCare!: boolean | null;

	@GandalfProperty({ designType: String })
	patientReasonForVisit!: string | null;

	@GandalfProperty({ designType: String })
	providerReasonForVisit!: string | null;

	@GandalfProperty({ designType: Number })
	referringProviderId!: number | null;

	@GandalfConstantDecorator(constants.TocReceivedStatus)
	@GandalfProperty({ designType: constants.TocReceivedStatus })
	tocReceivedStatus!: constants.TocReceivedStatus | null;

}
